// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_iconeAdd__FEG-E {
  color: #fff;
  font-size: 2rem;
}

.styles_iconeAdd__FEG-E:hover {
  color: #18316e;
}

.styles_containerButtons__Mr4ei {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ValoresFatura/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB","sourcesContent":[".iconeAdd {\n  color: #fff;\n  font-size: 2rem;\n}\n\n.iconeAdd:hover {\n  color: #18316e;\n}\n\n.containerButtons {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconeAdd": `styles_iconeAdd__FEG-E`,
	"containerButtons": `styles_containerButtons__Mr4ei`
};
export default ___CSS_LOADER_EXPORT___;
